// src/components/AddOnServices/AddOnServices.js

import React from "react";
import "./AddonServices.css";

import {
  FaAppleAlt,
  FaBrain,
  FaHandsHelping
} from "react-icons/fa";

function AddOnServices() {

  /* BOOK APPOINTMENT BUTTON CLICK */
  const handleBookNow = () => {
    const appointmentSection = document.getElementById("appointment");

    if (appointmentSection) {
      appointmentSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  const services = [
    {
      icon: <FaAppleAlt />,
      color: "#2E7D32",
      title: "Personalized Diet Plans",
      desc: "Customized nutrition guidance based on your body type, lifestyle, health condition, and wellness goals for faster recovery."
    },
    {
      icon: <FaBrain />,
      color: "#8E24AA",
      title: "Mental Health Counseling",
      desc: "Supportive counseling for stress, anxiety, emotional balance, motivation, confidence, and overall mental wellbeing."
    },
    {
      icon: <FaHandsHelping />,
      color: "#1565C0",
      title: "Parenting Assistance",
      desc: "Helpful guidance for child routines, emotional growth, behaviour management, study habits, and family harmony."
    }
  ];

  return (
    <section className="addon-section">

      <div className="addon-container">

        <p className="addon-tag">
          ADD-ON SERVICES
        </p>

        <h2>
          Extra Support For <br />
          Complete Wellness
        </h2>

        <p className="addon-subtitle">
          Holistic services designed to support your health journey beyond treatment.
        </p>

        <div className="addon-grid">

          {services.map((item, index) => (
            <div className="addon-card" key={index}>

              <div
                className="addon-icon"
                style={{
                  color: item.color
                }}
              >
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

              <button
                className="addon-btn"
                onClick={handleBookNow}
              >
                Book Appointment
              </button>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
}

export default AddOnServices;